'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import { useInstantSearch } from 'react-instantsearch';
import Link from 'components/consumer/Link';
import classNames from 'classnames';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import { getAdvancedSearchUrlForQueryAndIndex } from 'components/consumer/consumer-search/commons/helpers';

/**
 * SeeAllButton - Next/v7 version
 */
const SeeAllButtonNext = t0 => {
  const $ = _c(16);
  const {
    toggleSearchOpen,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const {
    results
  } = useInstantSearch();
  const currentPage = useUserCurrentPageType();
  let t2;
  if ($[0] !== currentPage || $[1] !== results?.query || $[2] !== toggleSearchOpen) {
    t2 = async () => {
      await toggleSearchOpen?.();
      avo.productsSearched({
        query: results?.query ?? "",
        location: currentPage,
        searchTarget: avo.SearchTarget.FULL_RESULTS
      });
    };
    $[0] = currentPage;
    $[1] = results?.query;
    $[2] = toggleSearchOpen;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  results?.query;
  const handleClick = t2;
  if (!results?.query) {
    return null;
  }
  let t3;
  if ($[4] !== results.query) {
    t3 = getAdvancedSearchUrlForQueryAndIndex(results.query, "products");
    $[4] = results.query;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = variant === "desktop";
  const t5 = variant === "mobile";
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = classNames("p-2.5 border-solid border-gray cursor-pointer font-bold tracking-[-.0125rem] leading-[1.45rem] text-base bg-gray", {
      "text-center w-[200px] h-[50px] border-2 text-white": t4,
      "text-left w-auto h-auto pt-0 pr-0 pb-0 pl-2.5 border-0 bg-transparent text-gray mr-5": t5
    });
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== results.nbHits || $[10] !== t6) {
    t7 = <div className={t6}>See full results ({results.nbHits})</div>;
    $[9] = results.nbHits;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== handleClick || $[13] !== t3 || $[14] !== t7) {
    t8 = <Link onClick={handleClick} to={t3}>{t7}</Link>;
    $[12] = handleClick;
    $[13] = t3;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default SeeAllButtonNext;